import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const KnowYourKyc = () => {
  useEffect(() => {
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <SEO
        title="Understand KYC Process & Requirements"
        description="Learn about Know Your Client (KYC) requirements, status checking, and validation links. Detailed guide on KYC Validated, Registered, and On-Hold statuses."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: "url('/images/other-banner.png')",
              }}
            >
              <canvas id="canvas" aria-hidden="true"></canvas>
              <div className="carousel-caption">
                <h1>Know your KYC</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <h5>1. What is Know Your Client (KYC)?</h5>
              <p>
                Know Your Client (KYC) means identifying and verifying the
                client’s identity and the identity of the beneficial owner
                through documents submitted for Proof of Identity (PoI) and
                Proof of Address (PoA) in compliance with rules, regulations,
                guidelines, and circulars issued by the Board or any other
                authority for Prevention of Money Laundering from time to time.
              </p>

              <h5>KYC Status Check Link</h5>
              <ul className="listitem">
                <li>
                  FOR CVL KRA:{" "}
                  <a
                    href="https://www.cvlkra.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    https://www.cvlkra.com/
                  </a>
                </li>
                <li>
                  FOR NDML KRA:{" "}
                  <a
                    href="https://kra.ndml.in/kra-web/jsps/menu/MainIndex.jsp"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    https://kra.ndml.in/kra-web/jsps/menu/MainIndex.jsp
                  </a>
                </li>
                <li>
                  FOR DOTEX KRA:{" "}
                  <a
                    href="https://www.nsekra.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    https://www.nsekra.com/
                  </a>
                </li>
                <li>
                  FOR KARVY KRA:{" "}
                  <a
                    href="https://www.karvykra.com/UPanSearchGlobalWithPanExempt.aspx"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    https://www.karvykra.com/UPanSearchGlobalWithPanExempt.aspx
                  </a>
                </li>
                <li>
                  FOR CAMS KRA:{" "}
                  <a
                    href="https://camskra.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    https://camskra.com/
                  </a>
                </li>
              </ul>

              <h5>Steps to Check Your KYC Status - CVL KRA</h5>
              <ul className="listitem">
                <li>Visit https://www.cvlkra.com/ and click on KYC Inquiry.</li>
                <li>
                  Enter your 10-digit PAN with Captcha and click on Submit.
                </li>
                <li>
                  Your KYC Status will be displayed as 'KYC Validated/KYC
                  Registered/KYC On-Hold/Under Process’.
                </li>
              </ul>

              <h5>What does each KYC status mean?</h5>

              <h5>KYC Validated</h5>
              <ul className="listitem">
                <li>KYC is registered successfully.</li>
                <li>
                  You can do any transaction in securities market, anytime.
                </li>
              </ul>

              <h5>KYC Registered</h5>
              <ul className="listitem">
                <li>
                  You can continue making transactions in your Trading and Demat
                  account without any hassle.
                </li>
                <li>
                  You can get your KYC status changed to ‘KYC Validated’ by
                  doing the KYC Update/KYC Modification process using PAN and
                  XML Aadhaar, Digi-locker or Masked Aadhaar.
                </li>
                <li>
                  Once your KYC status changes to “Validated” you can invest in
                  securities market without any requirement of re-KYC.
                </li>
              </ul>

              <h5>Under Process</h5>
              <ul className="listitem">
                <li>
                  This status shows up if the KYC is recently updated and under
                  processing at KRAs. It takes up to a few days for the KYC
                  status to be updated.
                </li>
              </ul>

              <h5>KYC On-Hold/Rejected</h5>
              <ul className="listitem">
                <li>
                  The KYC status on the KRA’s website shows the reason for ‘KYC
                  On-Hold/Rejected’ status; it could be: Mobile or Email not
                  validated/PAN is not linked with Aadhaar/Deficiency in the KYC
                  documents etc.
                </li>
                <li>
                  Please contact our nearest Centre for rectification of
                  discrepancies in KYC documents.
                </li>
                <li>
                  Once your KYC status changes to Registered/Validated you will
                  be all set to start transaction.
                </li>
              </ul>

              <h5>KRA Validation Link</h5>
              <p>The validation links are provided below for your reference:</p>
              <ul className="listitem">
                <li>
                  <a
                    href="https://validate.cvlindia.com/CVLKRAVerification_V1/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    https://validate.cvlindia.com/CVLKRAVerification_V1/
                  </a>
                </li>
                <li>
                  <a
                    href="https://kra.ndml.in/ClientInitiatedKYC-webApp/#/ClientinitiatedKYC"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    https://kra.ndml.in/ClientInitiatedKYC-webApp/#/ClientinitiatedKYC
                  </a>
                </li>
              </ul>
              <p>
                In case of any difficulties, feel free to contact our Helpdesk
                for further assistance.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                Download &amp; Explore More
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/app-pic.jpg"
                className="img-fluid"
                alt="App Preview"
              />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default KnowYourKyc;
